import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Accordion } from "react-bootstrap";
import heroBg from "../assets/images/HeroBanner.png";
import { useNavigate } from "react-router-dom";
import "../styles/FAQ.css";
import axios from "axios";

const FAQ = () => {
  const navigate = useNavigate();
  const [tokenState, setTokenState] = useState(localStorage.getItem("token"));
  const [faqData, setFaqData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const sectionRefs = useRef([]);

  const handleMemberLogin = () => {
    navigate("/member-login");
  };

  const handleEdcclogin = () => {
    navigate("/edcc-login");
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const currentToken = localStorage.getItem("token");
      if (currentToken !== tokenState){
        setTokenState(currentToken);
      }
    }, 500);
    return () => clearInterval(interval);
  }, [tokenState]);

  // Fetch FAQ data from backend
  useEffect(() => {
    const fetchFaqData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${process.env.REACT_APP_BASEURL}/getallhelp/cms`);
        
        // Extract FAQ data from response
        let faqItems = [];
        if (response.data && response.data.data) {
          faqItems = response.data.data.filter(item => 
            item.status === 1 && 
            !item.isDeleted && 
            item.faq_question && 
            item.faq_answer
          );
        } else if (Array.isArray(response.data)) {
          faqItems = response.data.filter(item => 
            item.status === 1 && 
            !item.isDeleted && 
            item.faq_question && 
            item.faq_answer
          );
        }
        
        setFaqData(faqItems);
        setError(null);
      } catch (err) {
        console.error("Error fetching FAQ data:", err);
        setError("Failed to load FAQ data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchFaqData();
  }, []);
  // Inside your component, before rendering
const groupedFaqs = faqData.reduce((acc, item) => {
  const key = item.title || "Others"; // fallback if title is missing
  if (!acc[key]) acc[key] = [];
  acc[key].push(item);
  return acc;
}, {});

// Smooth scroll handler
const handleAccordionClick = (index) => {
  const section = sectionRefs.current[index];
  if (!section) return;

  // Wait for the accordion animation (Bootstrap default is ~350ms)
  setTimeout(() => {
    section.focus();

    const headerOffset = 120; // adjust this to match your fixed header height
    const elementPosition = section.getBoundingClientRect().top + window.scrollY;
    const offsetPosition = elementPosition - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  }, 400); // wait for expand animation to finish
};




  if (loading) {
    return (
      <>
        {/* Hero Section */}
        <section
          className="hero-fixed"
          style={{ backgroundImage: `url(${heroBg})` }}
        >
          <div className="hero-content">
            <h1 className="hero-title">
              All India Occupational Therapists' Association
            </h1>
            <div className="hero-buttons">
              <button className="glass-button" onClick={handleMemberLogin}>
                Member Login
              </button>
              <button className="glass-button" onClick={handleEdcclogin}>
                Ergonomic Certificate Login
              </button>
            </div>
          </div>
        </section>

        {/* Scrollable Content */}
        <div className="scrollable-content">
          <div className="content-container faq-content-container">
            <section className="faq-section">
              <Container className="">
                <h2 className="text-center faq-heading mb-5">
                  Frequently Asked Questions
                </h2>
                <div className="text-center">
                  <p>Loading FAQs...</p>
                </div>
              </Container>
            </section>
          </div>
        </div>
      </>
    );
  }

  if (error) {
    return (
      <>
        {/* Hero Section */}
        <section
          className="hero-fixed"
          style={{ backgroundImage: `url(${heroBg})` }}
        >
          <div className="hero-content">
            <h1 className="hero-title">
              All India Occupational Therapists' Association
            </h1>
            <div className="hero-buttons">
              <button className="glass-button" onClick={handleMemberLogin}>
                Member Login
              </button>
              <button className="glass-button" onClick={handleEdcclogin}>
                Ergonomic Certificate Login
              </button>
            </div>
          </div>
        </section>

        {/* Scrollable Content */}
        <div className="scrollable-content">
          <div className="content-container faq-content-container">
            <section className="faq-section">
              <Container className="mt-5">
                <h2 className="text-center faq-heading mb-5">
                  Frequently Asked Questions
                </h2>
                <div className="text-center text-danger">
                  <p>{error}</p>
                </div>
              </Container>
            </section>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      {/* Fixed Hero Section */}
      <section
        className="hero-fixed"
        style={{ backgroundImage: `url(${heroBg})` }}>

        <div className="hero-scroll-content">
          <div className="hero-content-home poppins-regular">
            <h1 className="hero-heading">All India Occupational Therapists' Association</h1>
              {!tokenState && (
                <div className="hero-buttons">
                <button className="glass-button" onClick={handleMemberLogin}>
                  Member Login
                </button>
                <button className="glass-button" onClick={handleEdcclogin}>
                  Ergonomic Certificate login
                </button>
              </div>
              )}
          </div>
        </div>
      </section>

      {/* Scrollable Content Container */}
      <div className="scrollable-content-home">
        <div className="content-container faq-content-container">
          <section className="faq-section">
            <Container className="mt-5">
              <h2 className="text-center faq-heading mb-5">
                Frequently Asked Questions
              </h2>

              {/* FAQ Items from Database */}
<Row className="mb-4">
  <Col>
    {Object.keys(groupedFaqs).length === 0 ? (
      <div className="text-center no-data-message py-4">
        <h5 className="text-muted">No FAQs available at the moment.</h5>
        <p className="text-muted">Please check back later for updates.</p>
      </div>
    ) : (
                    Object.keys(groupedFaqs).map((title, titleIndex) => (
                      <div key={titleIndex} className="faq-group mb-4">
                        <h4 className="mb-3">{title}</h4>

                        <Accordion className="faq-accordion">
                          {groupedFaqs[title].map((item, index) => {
                            // Calculate absolute index for ref array
                            const globalIndex = titleIndex * 100 + index;
                            return (
                              <Accordion.Item
                                eventKey={item._id || `${titleIndex}-${index}`}
                                key={item._id || `${titleIndex}-${index}`}
                                className="faq-accordion-item"
                                ref={(el) =>
                                  (sectionRefs.current[globalIndex] = el)
                                }
                                tabIndex="-1"
                              >
                                <Accordion.Header
                                  className="faq-accordion-header"
                                  onClick={() =>
                                    handleAccordionClick(globalIndex)
                                  }
                                >
                                  {`${index + 1}. ${item.faq_question}`}
                                </Accordion.Header>
                                <Accordion.Body className="faq-accordion-body ms-5">
                                  {item.faq_answer}
                                </Accordion.Body>
                              </Accordion.Item>
                            );
                          })}
                        </Accordion>
                      </div>
                    ))
                  )}
                </Col>
              </Row>
            </Container>
          </section>
        </div>
      </div>
    </>
  );
};

export default FAQ;